import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { ScheduleAction } from '@cbridge-packages/schedule';

export const reloadScheduleListEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    ScheduleAction.create.done,
    ScheduleAction.update.done,
    ScheduleAction.remove.done,
  ),
  map(() => ScheduleAction.loadList.started({})),
);
